import React from 'react';
import StepOne from '../../atoms/icons/StepOne';
import StepThree from '../../atoms/icons/StepThree';
import StepTwo from '../../atoms/icons/StepTwo';
import { SITE_NAME } from '../../config/Master';

export const getTutorialData = (
  isAttractiveUser: boolean,
  customIconStyle: React.CSSProperties,
  isJoinPage = false
) => [
  {
    icon: <StepOne customStyle={customIconStyle} />,
    title: `What is a WYP date offer${isJoinPage ? ' you ask' : ''}?`,
    titleFontWeight: 700,
    content: [
      'It\'s a "first date incentive" given to Attractive members',
      'Offers can be initiated by either member group',
      'The incentive is always gifted by the Generous member',
    ],
    subTitle: "It's the ultimate ice breaker!",
  },
  {
    icon: <StepTwo customStyle={customIconStyle} />,
    title: `Send ${isAttractiveUser ? 'requests' : 'offers'} quickly and easily`,
    titleFontWeight: 700,
    content: [
      `From any member's profile, set your Offer ${isAttractiveUser ? 'Request' : ''} amount and click Send ${
        isAttractiveUser ? 'Request' : 'Offer'
      }`,
      `${isAttractiveUser ? 'Offer Requests' : 'Offers'} can be sent from other pages as well. Just look for the ${
        isAttractiveUser ? 'Request Offer' : 'Make Offer'
      } button.`,
    ],
    subTitle: `Don't be shy! ${isAttractiveUser ? 'Make an Offer Request!' : 'Send them Offer!'}`,
  },
  {
    icon: <StepThree customStyle={customIconStyle} />,
    titleFontWeight: 600,
    title: 'Accepted offers are just the beginning',
    content: [
      'Offers may be Accepted, Declined or Countered',
      'Once accepted, the Generous member must "unlock" messaging so communication can begin',
      `Lastly, incentives are given at the first date, not through the ${SITE_NAME} app.`,
    ],
    subTitle: 'Get Straight to the Date™',
  },
];
